import { LocalizedString as GraphQlLocalizedString } from "@acto/gql/graphql";

export default class LocalizedStringMap {
  #map: Map<string, string>;

  private constructor(map: Map<string, string>) {
    this.#map = map;
  }

  static fromGraphql(data: GraphQlLocalizedString[]): LocalizedStringMap {
    const map = new Map<string, string>();
    for (const item of data) {
      map.set(item.locale, item.value);
    }

    return new LocalizedStringMap(map);
  }

  public getTranslation(locale: string): string {
    const translated = this.#map.get(locale) || this.#map.values().next().value;

    if (!translated) {
      throw new Error(`No translation found for this string in any locale.`);
    }

    return translated;
  }

  public hasTranslations(): boolean {
    return this.#map.size > 0;
  }
}
